import { createContext, useContext, useState, useEffect } from "react";
import {
  ASSISTANT_STATUS,
  TUTOR_SESSION_PHASE_STATUS,
} from "@/features/tutor/constants";
const AssistantContext = createContext(null);

export const AssistantProvider = ({ children }) => {
  const [assistantStatus, setAssistantStatus] = useState(ASSISTANT_STATUS.IDLE);
  const [tutorSessionStatus, setTutorSessionStatus] = useState(
    TUTOR_SESSION_PHASE_STATUS.LOADING,
  );

  const isTutorSessionLoadingPhase =
    tutorSessionStatus === TUTOR_SESSION_PHASE_STATUS.LOADING;
  const isTutorSessionSpeakingPhase =
    tutorSessionStatus === TUTOR_SESSION_PHASE_STATUS.SPEAKING;
  const isTutorSessionListeningPhase =
    tutorSessionStatus === TUTOR_SESSION_PHASE_STATUS.LISTENING;

  return (
    <AssistantContext.Provider
      value={{
        assistantStatus,
        setAssistantStatus,
        isTutorSessionLoadingPhase,
        isTutorSessionSpeakingPhase,
        isTutorSessionListeningPhase,
        setTutorSessionStatus,
      }}
    >
      {children}
    </AssistantContext.Provider>
  );
};

export const useAssistant = () => useContext(AssistantContext);
